export default __webpack_public_path__ + "d0057508fa78aa3881cf4b3259026f40.png";